import React, { ReactNode } from 'react';
import clsx from "clsx";

import AppBox from '@/components/AppBox'

interface AppCardProps extends React.HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
}

const AppCard: React.FC<AppCardProps> = ({ children, className, ...props }) => {
  return (
    <AppBox
      column
      fullWidth
      className={clsx(
        "min-w-[300px] bg-white border rounded-md shadow-sm p-2 sm:p-4",
        className,
      )}
      {...props}
    >
      {children}
    </AppBox>
  );
};

export default AppCard;